module.exports = __webpack_public_path__ + "img/violet_045.cff7ab76.png";